export default "__VITE_ASSET__0b1368b8__"